// extracted by css-extract-rspack-plugin
export default {"cls1":"PodcastLibraryCarouselAd-cls1_kCM","cls2":"PodcastLibraryCarouselAd-cls2_-2X PodcastLibraryCarouselAd-cls1_kCM"};